import { GET_REVIEW_TAGS, CREATE_REVIEW_TAGS, UPDATE_REVIEW_TAGS, DELETE_REVIEW_QUOTE, RESET_REVIEW_TAGS, TOGGLE_IS_SAVED } from '../constants/reviewsConstants';
import cloneDeep from 'lodash/cloneDeep';

let initialState = {
    tags: {},
    quotesAndTags: {},
    review: null,
    isSaved: false,
};

function taggingDataReducer(state = initialState, action) {
    let newState = cloneDeep(state);
    switch (action.type) {
        case TOGGLE_IS_SAVED:
            return {...state, isSaved: false}
        case RESET_REVIEW_TAGS:
            return {...initialState}
        case GET_REVIEW_TAGS:
            return {...state, tags: action.payload.tags, quotesAndTags: action.payload.vendor_quotes_and_tags, review: action.payload.review};
        case CREATE_REVIEW_TAGS:
            if (newState.quotesAndTags.vendor_quotes) {
                newState.quotesAndTags.vendor_quotes.push(action.payload.vendor_quote);
                newState.quotesAndTags.quote_tags = [...newState.quotesAndTags.quote_tags, ...action.payload.quote_tags]
            }
            return {...newState, isSaved: true};
        case UPDATE_REVIEW_TAGS:
            newState.quotesAndTags.quote_tags = newState.quotesAndTags.quote_tags.filter((qt) => qt.key_point_id != action.payload.vendor_quote_id)
            newState.quotesAndTags.quote_tags = [...newState.quotesAndTags.quote_tags, ...action.payload.quote_tags];
            return {...newState, isSaved: true};
        case DELETE_REVIEW_QUOTE:
            if (newState.quotesAndTags.vendor_quotes) {
                newState.quotesAndTags.vendor_quotes = newState.quotesAndTags.vendor_quotes.filter((vq) => vq.id != action.payload);
                newState.quotesAndTags.quote_tags = newState.quotesAndTags.quote_tags.filter((qt) => qt.key_point_id != action.payload)
            }
            return {...newState}
        default:
            return state;
    }
}

export {
    taggingDataReducer
}